export default __webpack_public_path__ + "static/media/post_office_vanillaJS.95f5a4bd.PNG";